module.exports = __webpack_public_path__ + "img/category.e08c6679.svg";